import axios from "axios"
import { useAppDispatch } from "../redux/hooks";
import { DmwaError } from "../models/DmwaError";
import { getAccessToken } from "../redux/tokenSlice";


const options = {
	headers: {
		'Content-Type': 'application/json'
	},
	
	withCredentials: false
};

export const Logout = async(token: string, appDeviceId:string, callback:(res)=>void) => {

	const payload = {
		'tokens': token,
		'appdeviceid': appDeviceId
	}

	const headers = {
		'Content-Type': 'application/json',
		'Authorization': getAccessToken() as string
	}

	await axios.post(`${process.env.REACT_APP_AUTH_URL}/logoff`, payload, {headers: headers}).then(response => {

		callback(response)
	}).catch(error => {
		console.log('error = ', error)
		callback(new DmwaError(error.response?.status, error.message ))
	})
}

export const RequestToken = async(clientID:string, userName: string, password:string, callback:(res)=>void) => {

	const payload = {
		'clientid': clientID,
		'username': userName,
		'password': password
	}

	await axios.post(`${process.env.REACT_APP_AUTH_URL}/token`, payload, options).then(response => {

		callback(response)
	}).catch(error => {
		console.log('error = ', error)
		callback(new DmwaError(error.response?.status, error.message ))
	})
}


export const RequestTokenWithSession = async (geoTabDBName:string, userName: string, authToken:string, callback:(res)=>void) => {
	
	const payload = {
		'geoTabDBName': geoTabDBName,
		'username': userName,
		'authToken': authToken
	}

	await axios.post(`${process.env.REACT_APP_AUTH_URL}/token`, payload, options).then(response => {
		callback(response)
	}).catch(error => {
		console.log('error = ', error)
		callback(new DmwaError(error.response?.status, error.message ))
	})
}

export const RegisterToken = async (token:string, callback:(res)=>void) => {
	const payload = {
		'token': token
	}
	await axios.post(`${process.env.REACT_APP_AUTH_URL}/register`, payload, options).then(response => {
		callback(response)
	}).catch(error => {
		console.log('error = ', error)
		callback(new DmwaError(error.response?.status, error.message ))
	})
}

export const RefreshToken = async (token:string, callback:(res)=>void) => {
	const payload = {
		'tokens': token
	}
	await axios.post(`${process.env.REACT_APP_AUTH_URL}/refresh`, payload, options).then(response => {
		callback(response)
	}).catch(error => {
		console.log('error = ', error)
		callback(new DmwaError(error.response?.status, error.message ))
	})
}

export const RegisterPushToken = async (token:string, appDeviceId:string, callback:(res)=>void) => {

	const headers = {
		'Content-Type': 'application/json',
		'Authorization': getAccessToken() as string
	  }

	const payload = {
		'token': token,
		'appdeviceid': appDeviceId
	}
	await axios.post(`${process.env.REACT_APP_AUTH_URL}/registerpushtoken`, payload, {headers: headers}).then(response => {
		callback(response)
	}).catch(error => {
		console.log('error = ', error)
		callback(new DmwaError(error.response?.status, error.message ))
	})
}